export default function Layout({ children }: { children?: React.ReactNode }) {
  // These event handlers were present on an older version,
  // for unclear reasons not described in a comment or in the
  // git history:
  //   onDragOver={(evt) => evt.preventDefault()}
  //   onDrop={(evt) => evt.preventDefault()}
  return <div className="min-h-screen">{children}</div>;
}
